/**
 * 常用方法
 * @Description:
 *
 * @Author: JZT.Oscar
 * @Date: 2018-09-26 21:45:11
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2018-10-18 16:19:53
 */
import {
    EnvConf
} from "@/libs/config";

// 获得当前环境
const getCurrentEnv = () => {
    // 判断站点基础域名
    switch (document.domain) {
        case EnvConf.prod.domain:
            return "prod";
        case EnvConf.pre.domain:
            return "pre";
        case EnvConf.test2.domain:
            return "test2";
        default:
            return "dev";
    }
};
// 获得当前服务接口域名
const getCurrentServiceDomain = () => {
    return window.location.protocol + "//" + document.domain;
    // return window.location.protocol+"//"+EnvConf[getCurrentEnv()].service;
};
// 判断请求头是否为文件上传
const isUploadFile = xhr => {
    return (
        xhr.headers["Content-Type"] &&
        xhr.headers["Content-Type"].indexOf("multipart/form-data") > -1
    );
};




// 将时间戳转给指定格式时间
const __toDateString = (timespan, format = "yyyy-MM-dd hh:mm") => {
    let self = new Date(timespan);
    let date = {
        "M+": self.getMonth() + 1,
        "d+": self.getDate(),
        "h+": self.getHours(),
        "m+": self.getMinutes(),
        "s+": self.getSeconds(),
        "q+": Math.floor((self.getMonth() + 3) / 3),
        "S+": self.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (self.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in date) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
        }
    }
    return format;
}



export {
    getCurrentEnv,
    getCurrentServiceDomain,
    isUploadFile,
    __toDateString
};



// WEBPACK FOOTER //
// ./src/libs/common.js